<template>
    <div
        class="modal-popup"
        v-if="!isDismissed && (canInstallPwa || isApple) && !isPwa"
    >
        <div class="modal-popup-wrapper">
            <div class="modal-popup-header">
                <h2 class="modal-popup-title">
                    {{ $t("Hi") }}
                </h2>
                <button class="modal-popup-close" @click="closeInstallPopup">
                    <iconClose width="24" height="24" aria-hidden="true" />
                </button>
            </div>
            <div class="modal-popup-content">
                <p v-if="isApple">
                    {{
                        $t(
                            "This App functions even better when you install it"
                        )
                    }}.
                    {{ $t("Press") }}
                    <iconShare width="24" height="24" aria-hidden="true" />
                    {{ $t("and choose") }}
                    <iconPlusSquare width="24" height="24" aria-hidden="true" />
                    {{ $t("Add to home screen") }}"
                </p>
                <template v-if="!isApple && canInstallPwa">
                    <p>
                        {{
                            $t(
                                "This App functions even better when you install it. Install the Project Gezond App on the home screen."
                            )
                        }}
                    </p>
                    <button class="btn btn-primary" @click="promptPWA()">
                        {{ $t("Install Project Gezond as app") }}
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import PWA from "@/lib/PWA";
import iconClose from "@/assets/icons/icon-close.svg";
import iconShare from "@/assets/icons/icon-share.svg";
import iconPlusSquare from "@/assets/icons/icon-plus-square.svg";

export default {
    name: "InstallPopup",

    components: {
        iconClose,
        iconShare,
        iconPlusSquare,
    },
    data() {
        return {
            isApple: null,
            isDismissed: true,
            canInstallPwa: false,
            isPwa: false,
        };
    },
    async mounted() {
        this.detectPwaMode();
        this.isApple = PWA.isApple();

        if (localStorage.getItem("install-popup-dismissed") !== "1") {
            this.isDismissed = false;
        }

        setInterval(() => {
            this.canInstallPwa = PWA.HasInstallAvailable();
        }, 1000);
    },
    methods: {
        promptPWA() {
            PWA.PromptInstall();
        },
        closeInstallPopup() {
            localStorage.setItem("install-popup-dismissed", "1");
            this.isDismissed = true;
        },
        detectPwaMode() {
            this.isPwa =
                window.matchMedia("(display-mode: standalone)").matches ||
                window.navigator.standalone === true;
        },
    },
};
</script>

<style lang="scss">
@use "index";
</style>
